// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-main {
  width: 260px;
  height: 100vh;
  background-color: white;
  color: black;
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
  overflow-x: hidden;
  position: relative;
  z-index: 20;
}

.sidebar-main.sidebar-collapsed {
  width: 80px;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 1.25rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s;
}

.sidebar-header.header-active {
  background-color: transparent; /* No full header bg change */
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.sidebar-logo-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
  color: white;
  border-radius: 0.5rem;
  font-weight: 700;
  font-size: 1rem;
  transition: background 0.2s;
}

.sidebar-logo-text {
  font-weight: 700;
  font-size: 1.25rem;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: black !important; /* Permanent black */
}

/* Dynamic background for SS based on active color */
.header-active.blue .sidebar-logo-icon {
  background: #3b82f6;
}
.header-active.purple .sidebar-logo-icon {
  background: #8b5cf6;
}
.header-active.orange .sidebar-logo-icon {
  background: #f97316;
}
.header-active.red .sidebar-logo-icon {
  background: #ef4444;
}
.header-active.green .sidebar-logo-icon {
  background: #22c55e;
}
.header-active.teal .sidebar-logo-icon {
  background: #14b8a6;
}
.header-active.indigo .sidebar-logo-icon {
  background: #4b0082;
}
.header-active.yellow .sidebar-logo-icon {
  background: #fbbf24;
}
.header-active.emerald .sidebar-logo-icon {
  background: #059669;
}
.header-active.gray .sidebar-logo-icon {
  background: #6b7280;
}
.header-active.lime .sidebar-logo-icon {
  background: #84cc16;
}
.header-active.pink .sidebar-logo-icon {
  background: #ec4899;
}
.header-active.violet .sidebar-logo-icon {
  background: #a855f7;
}
.header-active.cyan .sidebar-logo-icon {
  background: #06b6d4;
}
.header-active.amber .sidebar-logo-icon {
  background: #d97706;
}
.header-active.rose .sidebar-logo-icon {
  background: #f43f5e;
}
.header-active.sky .sidebar-logo-icon {
  background: #0ea5e9;
}
.header-active.brown .sidebar-logo-icon {
  background: #a52a2a;
}

.sidebar-collapse-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.375rem;
  background-color: rgb(66 136 247);
  border: none;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
}

/* Change collapse button bg to match active color */
.header-active.blue .sidebar-collapse-button {
  background-color: #3b82f6;
}
.header-active.purple .sidebar-collapse-button {
  background-color: #8b5cf6;
}
.header-active.orange .sidebar-collapse-button {
  background-color: #f97316;
}
.header-active.red .sidebar-collapse-button {
  background-color: #ef4444;
}
.header-active.green .sidebar-collapse-button {
  background-color: #22c55e;
}
.header-active.teal .sidebar-collapse-button {
  background-color: #14b8a6;
}
.header-active.indigo .sidebar-collapse-button {
  background-color: #4b0082;
}
.header-active.yellow .sidebar-collapse-button {
  background: #fbbf24;
}
.header-active.emerald .sidebar-collapse-button {
  background-color: #059669;
}
.header-active.gray .sidebar-collapse-button {
  background-color: #6b7280;
}
.header-active.lime .sidebar-collapse-button {
  background-color: #84cc16;
}
.header-active.pink .sidebar-collapse-button {
  background-color: #ec4899;
}
.header-active.violet .sidebar-collapse-button {
  background-color: #a855f7;
}
.header-active.cyan .sidebar-collapse-button {
  background-color: #06b6d4;
}
.header-active.amber .sidebar-collapse-button {
  background-color: #d97706;
}
.header-active.rose .sidebar-collapse-button {
  background-color: #f43f5e;
}
.header-active.sky .sidebar-collapse-button {
  background-color: #0ea5e9;
}
.header-active.brown .sidebar-collapse-button {
  background-color: #a52a2a;
}

.sidebar-collapse-button:hover {
  opacity: 0.9;
}

.sidebar-nav {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 1.25rem 0;
  overflow-y: auto;
  scrollbar-width: none;
}

.sidebar-main::-webkit-scrollbar {
  display: none;
}

.sidebar-nav-section {
  margin-bottom: 1.5rem;
}

.sidebar-nav-section-title {
  display: block;
  padding: 0 1rem;
  margin-bottom: 0.75rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
}

.sidebar-main.sidebar-collapsed .sidebar-nav-section-title {
  text-align: center;
  font-size: 0.625rem;
}

.sidebar-nav-items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-nav-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.25rem;
  color: black;
  text-decoration: none;
  transition: all 0.2s;
  border-left: 3px solid transparent сохра;
  position: relative;
  cursor: pointer;
}

.sidebar-main.sidebar- collapsed .sidebar-nav-item {
  padding: 0.75rem;
  justify-content: center;
}

.sidebar-nav-item:hover {
  background-color: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.sidebar-nav-items li .sidebar-active {
  color: white;
}

.sidebar-nav-items li:hover {
  background-color: rgba(59, 130, 246, 0.1);
}

.sidebar-nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  color: black; /* Default icon color */
}

.dashboard-icon {
  color: black !important;
}

.sidebar-module-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.375rem;
  background-color: rgb(255 255 255 / 10%);
  margin-right: 0.75rem;
}

.sidebar-module-icon.blue {
  color: #3b82f6;
}
.sidebar-module-icon.purple {
  color: #8b5cf6;
}
.sidebar-module-icon.orange {
  color: #f97316;
}
.sidebar-module-icon.red {
  color: #ef4444;
}
.sidebar-module-icon.green {
  color: #22c55e;
}
.sidebar-module-icon.teal {
  color: #14b8a6;
}
.sidebar-module-icon.indigo {
  color: #4b0082;
}
.sidebar-module-icon.yellow {
  color: #fbbf24;
}
.sidebar-module-icon.emerald {
  color: #059669;
}
.sidebar-module-icon.gray {
  color: #6b7280;
}
.sidebar-module-icon.lime {
  color: #84cc16;
}
.sidebar-module-icon.pink {
  color: #ec4899;
}
.sidebar-module-icon.violet {
  color: #a855f7;
}
.sidebar-module-icon.cyan {
  color: #06b6d4;
}
.sidebar-module-icon.amber {
  color: #d97706;
}
.sidebar-module-icon.rose {
  color: #f43f5e;
}
.sidebar-module-icon.sky {
  color: #0ea5e9;
}
.sidebar-module-icon.brown {
  color: #a52a2a;
}

.sidebar-main.sidebar-collapsed .sidebar-nav-icon,
.sidebar-main.sidebar-collapsed .sidebar-module-icon {
  margin-right: 0;
}

.sidebar-nav-text {
  font-size: 0.875rem;
  font-weight: 500;
  flex: 1 1;
}

.dashboard-text {
  color: black !important;
}

/* Force black even when active for Dashboard */
.dashboard-item.sidebar-active .sidebar-nav-text {
  color: black !important;
  background-color: rgba(59, 130, 246, 0.1) !important;
  border-left-color: #3b82f6 !important;
}

.dashboard-item.sidebar-active .sidebar-nav-text,
.dashboard-item.sidebar-active {
  color: black !important;
}

.dashboard-item.sidebar-active .dashboard-icon {
  color: black !important;
}

.favorite-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.25rem;
  background-color: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.2s;
  opacity: 0;
}

.sidebar-nav-item:hover .favorite-button {
  opacity: 1;
}

.favorite-button.active {
  color: #f59e0b;
  opacity: 1;
}

.favorite-button:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.sidebar-footer {
  padding: 1.25rem 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.sidebar-submenu-arrow {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 0.25rem;
}

.sidebar-submenu-arrow:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.sidebar-submenu-arrow.sidebar-expanded {
  transform: rotate(180deg);
}

.sidebar-submenu {
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: white;
  border-left: 2px solid #3b82f6;
  margin-left: 1.25rem;
  margin-right: 1.25rem;
  border-radius: 0 0.375rem 0.375rem 0;
  overflow: hidden;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 300px;
  }
}

.sidebar-submenu-item {
  padding: 0.5rem 1rem;
  margin: 0;
  border-left: none;
  font-size: 0.8rem;
}

.sidebar-submenu-item:hover {
  background-color: rgba(0, 0, 0, 0.08);
}

/* Submenu active styling handled by inline style now */

/* Icon color white on active for submenus - override in inline if needed */
.sidebar-submenu li .sidebar-active .sidebar-submenu-icon {
  color: white !important;
}

.sidebar-submenu-icon {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
}

.sidebar-main.sidebar-collapsed .sidebar-submenu-arrow {
  display: none;
}

.sidebar-main.sidebar-collapsed .sidebar-submenu {
  display: none;
}

.has-submenu {
  cursor: pointer;
}

/* Active state base - but background now from inline */
.sidebar-nav-item.sidebar-active {
  color: white;
  border-left-color: currentColor;
}

/* Icon color white on active for modules */
.sidebar-nav-item.sidebar-active .sidebar-module-icon,
.sidebar-nav-item.sidebar-active .sidebar-nav-icon {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.2);
}

/* Override for Dashboard icon - keep black */
.dashboard-item.sidebar-active .sidebar-nav-icon {
  color: black !important;
  background-color: transparent !important;
}

/* Hover for color-specific items (light tint) */
.sidebar-nav-item.blue:hover {
  background-color: rgba(59, 130, 246, 0.1);
}
.sidebar-nav-item.purple:hover {
  background-color: rgba(139, 92, 246, 0.1);
}
.sidebar-nav-item.orange:hover {
  background-color: rgba(249, 115, 22, 0.1);
}
.sidebar-nav-item.red:hover {
  background-color: rgba(239, 68, 68, 0.1);
}
.sidebar-nav-item.green:hover {
  background-color: rgba(34, 197, 94, 0.1);
}
.sidebar-nav-item.teal:hover {
  background-color: rgba(20, 184, 166, 0.1);
}
.sidebar-nav-item.indigo:hover {
  background-color: rgba(149, 0, 255, 0.1);
}
.sidebar-nav-item.yellow:hover {
  background-color: rgba(251, 191, 36, 0.1);
}
.sidebar-nav-item.emerald:hover {
  background-color: rgba(5, 150, 105, 0.1);
}
.sidebar-nav-item.gray:hover {
  background-color: rgba(107, 114, 128, 0.1);
}
.sidebar-nav-item.lime:hover {
  background-color: rgba(132, 204, 22, 0.1);
}
.sidebar-nav-item.pink:hover {
  background-color: rgba(236, 72, 153, 0.1);
}
.sidebar-nav-item.violet:hover {
  background-color: rgba(168, 85, 247, 0.1);
}
.sidebar-nav-item.cyan:hover {
  background-color: rgba(6, 182, 212, 0.1);
}
.sidebar-nav-item.amber:hover {
  background-color: rgba(217, 119, 6, 0.1);
}
.sidebar-nav-item.rose:hover {
  background-color: rgba(244, 63, 94, 0.1);
}
.sidebar-nav-item.sky:hover {
  background-color: rgba(14, 165, 233, 0.1);
}
.sidebar-nav-item.brown:hover {
  background-color: rgba(165, 42, 42, 0.1);
}

@media (max-width: 768px) {
  .sidebar-main {
    position: fixed;
    z-index: 50;
    transform: translateX(-100%);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  }
  .sidebar-main.sidebar-open {
    transform: translateX(0);
  }
  .sidebar-main.sidebar-collapsed {
    transform: translateX(-100%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Sidebar/sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,6BAA6B,EAAE,6BAA6B;AAC9D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB,EAAE,oBAAoB;AAC/C;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,YAAY;EACZ,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA,oDAAoD;AACpD;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY,EAAE,uBAAuB;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;EACE,uBAAuB;EACvB,oDAAoD;EACpD,qCAAqC;AACvC;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;EACpC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,uDAAuD;;AAEvD,2EAA2E;AAC3E;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA,2CAA2C;AAC3C;;EAEE,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA,gDAAgD;AAChD;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,4BAA4B;IAC5B,uCAAuC;EACzC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".sidebar-main {\n  width: 260px;\n  height: 100vh;\n  background-color: white;\n  color: black;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.3s ease;\n  overflow-x: hidden;\n  position: relative;\n  z-index: 20;\n}\n\n.sidebar-main.sidebar-collapsed {\n  width: 80px;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.5rem 1.25rem;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  transition: background-color 0.2s;\n}\n\n.sidebar-header.header-active {\n  background-color: transparent; /* No full header bg change */\n}\n\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.sidebar-logo-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);\n  color: white;\n  border-radius: 0.5rem;\n  font-weight: 700;\n  font-size: 1rem;\n  transition: background 0.2s;\n}\n\n.sidebar-logo-text {\n  font-weight: 700;\n  font-size: 1.25rem;\n  letter-spacing: 0.05em;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: black !important; /* Permanent black */\n}\n\n/* Dynamic background for SS based on active color */\n.header-active.blue .sidebar-logo-icon {\n  background: #3b82f6;\n}\n.header-active.purple .sidebar-logo-icon {\n  background: #8b5cf6;\n}\n.header-active.orange .sidebar-logo-icon {\n  background: #f97316;\n}\n.header-active.red .sidebar-logo-icon {\n  background: #ef4444;\n}\n.header-active.green .sidebar-logo-icon {\n  background: #22c55e;\n}\n.header-active.teal .sidebar-logo-icon {\n  background: #14b8a6;\n}\n.header-active.indigo .sidebar-logo-icon {\n  background: #4b0082;\n}\n.header-active.yellow .sidebar-logo-icon {\n  background: #fbbf24;\n}\n.header-active.emerald .sidebar-logo-icon {\n  background: #059669;\n}\n.header-active.gray .sidebar-logo-icon {\n  background: #6b7280;\n}\n.header-active.lime .sidebar-logo-icon {\n  background: #84cc16;\n}\n.header-active.pink .sidebar-logo-icon {\n  background: #ec4899;\n}\n.header-active.violet .sidebar-logo-icon {\n  background: #a855f7;\n}\n.header-active.cyan .sidebar-logo-icon {\n  background: #06b6d4;\n}\n.header-active.amber .sidebar-logo-icon {\n  background: #d97706;\n}\n.header-active.rose .sidebar-logo-icon {\n  background: #f43f5e;\n}\n.header-active.sky .sidebar-logo-icon {\n  background: #0ea5e9;\n}\n.header-active.brown .sidebar-logo-icon {\n  background: #a52a2a;\n}\n\n.sidebar-collapse-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 0.375rem;\n  background-color: rgb(66 136 247);\n  border: none;\n  color: #ffffff;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n/* Change collapse button bg to match active color */\n.header-active.blue .sidebar-collapse-button {\n  background-color: #3b82f6;\n}\n.header-active.purple .sidebar-collapse-button {\n  background-color: #8b5cf6;\n}\n.header-active.orange .sidebar-collapse-button {\n  background-color: #f97316;\n}\n.header-active.red .sidebar-collapse-button {\n  background-color: #ef4444;\n}\n.header-active.green .sidebar-collapse-button {\n  background-color: #22c55e;\n}\n.header-active.teal .sidebar-collapse-button {\n  background-color: #14b8a6;\n}\n.header-active.indigo .sidebar-collapse-button {\n  background-color: #4b0082;\n}\n.header-active.yellow .sidebar-collapse-button {\n  background: #fbbf24;\n}\n.header-active.emerald .sidebar-collapse-button {\n  background-color: #059669;\n}\n.header-active.gray .sidebar-collapse-button {\n  background-color: #6b7280;\n}\n.header-active.lime .sidebar-collapse-button {\n  background-color: #84cc16;\n}\n.header-active.pink .sidebar-collapse-button {\n  background-color: #ec4899;\n}\n.header-active.violet .sidebar-collapse-button {\n  background-color: #a855f7;\n}\n.header-active.cyan .sidebar-collapse-button {\n  background-color: #06b6d4;\n}\n.header-active.amber .sidebar-collapse-button {\n  background-color: #d97706;\n}\n.header-active.rose .sidebar-collapse-button {\n  background-color: #f43f5e;\n}\n.header-active.sky .sidebar-collapse-button {\n  background-color: #0ea5e9;\n}\n.header-active.brown .sidebar-collapse-button {\n  background-color: #a52a2a;\n}\n\n.sidebar-collapse-button:hover {\n  opacity: 0.9;\n}\n\n.sidebar-nav {\n  flex: 1 1;\n  display: flex;\n  flex-direction: column;\n  padding: 1.25rem 0;\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n\n.sidebar-main::-webkit-scrollbar {\n  display: none;\n}\n\n.sidebar-nav-section {\n  margin-bottom: 1.5rem;\n}\n\n.sidebar-nav-section-title {\n  display: block;\n  padding: 0 1rem;\n  margin-bottom: 0.75rem;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #94a3b8;\n}\n\n.sidebar-main.sidebar-collapsed .sidebar-nav-section-title {\n  text-align: center;\n  font-size: 0.625rem;\n}\n\n.sidebar-nav-items {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar-nav-item {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 1.25rem;\n  color: black;\n  text-decoration: none;\n  transition: all 0.2s;\n  border-left: 3px solid transparent сохра;\n  position: relative;\n  cursor: pointer;\n}\n\n.sidebar-main.sidebar- collapsed .sidebar-nav-item {\n  padding: 0.75rem;\n  justify-content: center;\n}\n\n.sidebar-nav-item:hover {\n  background-color: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n}\n\n.sidebar-nav-items li .sidebar-active {\n  color: white;\n}\n\n.sidebar-nav-items li:hover {\n  background-color: rgba(59, 130, 246, 0.1);\n}\n\n.sidebar-nav-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 0.75rem;\n  color: black; /* Default icon color */\n}\n\n.dashboard-icon {\n  color: black !important;\n}\n\n.sidebar-module-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 0.375rem;\n  background-color: rgb(255 255 255 / 10%);\n  margin-right: 0.75rem;\n}\n\n.sidebar-module-icon.blue {\n  color: #3b82f6;\n}\n.sidebar-module-icon.purple {\n  color: #8b5cf6;\n}\n.sidebar-module-icon.orange {\n  color: #f97316;\n}\n.sidebar-module-icon.red {\n  color: #ef4444;\n}\n.sidebar-module-icon.green {\n  color: #22c55e;\n}\n.sidebar-module-icon.teal {\n  color: #14b8a6;\n}\n.sidebar-module-icon.indigo {\n  color: #4b0082;\n}\n.sidebar-module-icon.yellow {\n  color: #fbbf24;\n}\n.sidebar-module-icon.emerald {\n  color: #059669;\n}\n.sidebar-module-icon.gray {\n  color: #6b7280;\n}\n.sidebar-module-icon.lime {\n  color: #84cc16;\n}\n.sidebar-module-icon.pink {\n  color: #ec4899;\n}\n.sidebar-module-icon.violet {\n  color: #a855f7;\n}\n.sidebar-module-icon.cyan {\n  color: #06b6d4;\n}\n.sidebar-module-icon.amber {\n  color: #d97706;\n}\n.sidebar-module-icon.rose {\n  color: #f43f5e;\n}\n.sidebar-module-icon.sky {\n  color: #0ea5e9;\n}\n.sidebar-module-icon.brown {\n  color: #a52a2a;\n}\n\n.sidebar-main.sidebar-collapsed .sidebar-nav-icon,\n.sidebar-main.sidebar-collapsed .sidebar-module-icon {\n  margin-right: 0;\n}\n\n.sidebar-nav-text {\n  font-size: 0.875rem;\n  font-weight: 500;\n  flex: 1;\n}\n\n.dashboard-text {\n  color: black !important;\n}\n\n/* Force black even when active for Dashboard */\n.dashboard-item.sidebar-active .sidebar-nav-text {\n  color: black !important;\n  background-color: rgba(59, 130, 246, 0.1) !important;\n  border-left-color: #3b82f6 !important;\n}\n\n.dashboard-item.sidebar-active .sidebar-nav-text,\n.dashboard-item.sidebar-active {\n  color: black !important;\n}\n\n.dashboard-item.sidebar-active .dashboard-icon {\n  color: black !important;\n}\n\n.favorite-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 0.25rem;\n  background-color: transparent;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: all 0.2s;\n  opacity: 0;\n}\n\n.sidebar-nav-item:hover .favorite-button {\n  opacity: 1;\n}\n\n.favorite-button.active {\n  color: #f59e0b;\n  opacity: 1;\n}\n\n.favorite-button:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-footer {\n  padding: 1.25rem 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-submenu-arrow {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s ease;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 0.25rem;\n}\n\n.sidebar-submenu-arrow:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-submenu-arrow.sidebar-expanded {\n  transform: rotate(180deg);\n}\n\n.sidebar-submenu {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  background-color: white;\n  border-left: 2px solid #3b82f6;\n  margin-left: 1.25rem;\n  margin-right: 1.25rem;\n  border-radius: 0 0.375rem 0.375rem 0;\n  overflow: hidden;\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    max-height: 300px;\n  }\n}\n\n.sidebar-submenu-item {\n  padding: 0.5rem 1rem;\n  margin: 0;\n  border-left: none;\n  font-size: 0.8rem;\n}\n\n.sidebar-submenu-item:hover {\n  background-color: rgba(0, 0, 0, 0.08);\n}\n\n/* Submenu active styling handled by inline style now */\n\n/* Icon color white on active for submenus - override in inline if needed */\n.sidebar-submenu li .sidebar-active .sidebar-submenu-icon {\n  color: white !important;\n}\n\n.sidebar-submenu-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-right: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #94a3b8;\n}\n\n.sidebar-main.sidebar-collapsed .sidebar-submenu-arrow {\n  display: none;\n}\n\n.sidebar-main.sidebar-collapsed .sidebar-submenu {\n  display: none;\n}\n\n.has-submenu {\n  cursor: pointer;\n}\n\n/* Active state base - but background now from inline */\n.sidebar-nav-item.sidebar-active {\n  color: white;\n  border-left-color: currentColor;\n}\n\n/* Icon color white on active for modules */\n.sidebar-nav-item.sidebar-active .sidebar-module-icon,\n.sidebar-nav-item.sidebar-active .sidebar-nav-icon {\n  color: white !important;\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n/* Override for Dashboard icon - keep black */\n.dashboard-item.sidebar-active .sidebar-nav-icon {\n  color: black !important;\n  background-color: transparent !important;\n}\n\n/* Hover for color-specific items (light tint) */\n.sidebar-nav-item.blue:hover {\n  background-color: rgba(59, 130, 246, 0.1);\n}\n.sidebar-nav-item.purple:hover {\n  background-color: rgba(139, 92, 246, 0.1);\n}\n.sidebar-nav-item.orange:hover {\n  background-color: rgba(249, 115, 22, 0.1);\n}\n.sidebar-nav-item.red:hover {\n  background-color: rgba(239, 68, 68, 0.1);\n}\n.sidebar-nav-item.green:hover {\n  background-color: rgba(34, 197, 94, 0.1);\n}\n.sidebar-nav-item.teal:hover {\n  background-color: rgba(20, 184, 166, 0.1);\n}\n.sidebar-nav-item.indigo:hover {\n  background-color: rgba(149, 0, 255, 0.1);\n}\n.sidebar-nav-item.yellow:hover {\n  background-color: rgba(251, 191, 36, 0.1);\n}\n.sidebar-nav-item.emerald:hover {\n  background-color: rgba(5, 150, 105, 0.1);\n}\n.sidebar-nav-item.gray:hover {\n  background-color: rgba(107, 114, 128, 0.1);\n}\n.sidebar-nav-item.lime:hover {\n  background-color: rgba(132, 204, 22, 0.1);\n}\n.sidebar-nav-item.pink:hover {\n  background-color: rgba(236, 72, 153, 0.1);\n}\n.sidebar-nav-item.violet:hover {\n  background-color: rgba(168, 85, 247, 0.1);\n}\n.sidebar-nav-item.cyan:hover {\n  background-color: rgba(6, 182, 212, 0.1);\n}\n.sidebar-nav-item.amber:hover {\n  background-color: rgba(217, 119, 6, 0.1);\n}\n.sidebar-nav-item.rose:hover {\n  background-color: rgba(244, 63, 94, 0.1);\n}\n.sidebar-nav-item.sky:hover {\n  background-color: rgba(14, 165, 233, 0.1);\n}\n.sidebar-nav-item.brown:hover {\n  background-color: rgba(165, 42, 42, 0.1);\n}\n\n@media (max-width: 768px) {\n  .sidebar-main {\n    position: fixed;\n    z-index: 50;\n    transform: translateX(-100%);\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  }\n  .sidebar-main.sidebar-open {\n    transform: translateX(0);\n  }\n  .sidebar-main.sidebar-collapsed {\n    transform: translateX(-100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
